class InlineCountdownTimer extends HTMLElement {
  connectedCallback() {
    this.timezone = this.timeStringToFloat(this.dataset.timezone);
    this.countDownDate = new Date(`${this.dataset.endDate} ${this.dataset.endTime}:00`).getTime();

    if (isNaN(this.countDownDate)) {
      this.remove();
      return;
    }

    this.parts = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.tick();
    this.classList.add('inline-countdown--ready');
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  timeStringToFloat(time) {
    const hoursMinutes = (time || '').split(/[.:]/);
    const hours = parseInt(hoursMinutes[0], 10) || 0;
    const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
  }

  convertTimezone(timezone) {
    const now = new Date();
    const localTime = now.getTime();
    const localOffset = now.getTimezoneOffset() * 60000;
    const utc = localTime + localOffset;
    return new Date(utc + 3600000 * timezone);
  }

  tick() {
    const now = this.convertTimezone(this.timezone).getTime();
    const diff = Math.max(0, this.countDownDate - now);
    const totalSeconds = Math.floor(diff / 1000);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const showDays = days > 0;
    const showHours = showDays || hours > 0;
    const showMinutes = showHours || minutes > 0;

    this.updateUnit('days', days, showDays);
    this.updateUnit('hours', hours, showHours);
    this.updateUnit('minutes', minutes, showMinutes);
    this.updateUnit('seconds', seconds, true);

    if (diff === 0) {
      clearInterval(this.timer);
    }
  }

  updateUnit(unit, value, show) {
    const part = this.parts[unit];
    if (!part) return;
    part.hidden = !show;
    if (show) {
      part.querySelector('[data-num]').textContent = String(value).padStart(2, '0');
    }
  }
}

customElements.define('inline-countdown-timer', InlineCountdownTimer);
